import {makeStyles} from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  card: {
    display:'flex',
    flexDirection:'column',
    margin: '0 auto',
    maxWidth: 900,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
    gap: 20,
    padding: 20,
    overflowY: 'auto',

    '@media screen and (max-width: 650px)': {
      gridTemplateColumns: '1fr',
    },
  },
  description: {
    textAlign: 'justify',
    whiteSpace: 'normal',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    flexDirection: 'column',
    position: 'sticky',
    top: 0,

    '& h3': {
      margin: 0,
      textAlign: 'center',
    }
  },
  listActivities: {
    display: 'flex',
    gap: 5,
    flexWrap: 'wrap',
  },
  containerImg: {
    width: 200,
    height: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    objectFit: 'cover',
    overflow: 'hidden',
    borderRadius: 30,

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: 30,
      padding: 0,
    }
  },
}));
